import { useSelector } from 'react-redux';
import { RestrictionMessage, RouteWrapper, View } from '../../../component';
import Constants from '../../../constants';
import { MatchTabCricket, MatchTabFootball, MatchTabYesNo } from '../../../fantasy_games';
import { isBannedStateForFantasySports } from '../../../utilities/helper';
import { useLink } from 'react-router-stack';
import NavigationHeader from '../../../component/navigation_header';
import './index_mWeb.css';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';
const FantasyHomeMWeb = ({ gameType }: any) => {
  const navigate = useLink();
  const { currentLocationState = '' } = useSelector((state: any) => state.app);

  const isBanned = isBannedStateForFantasySports(currentLocationState);
  const title =
    gameType === Constants.GameType.FANTASY_CRICKET
      ? 'Fantasy Cricket'
      : gameType === Constants.GameType.FANTASY_FOOTBALL
      ? 'Fantasy Football'
      : 'Fantasy Yes/NO';
  const onClickBack = () => {
    try {
      navigate.push('/');
    } catch (err) {
      navigate.go(-1);
    }
  };
  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <NavigationHeader onClickBack={onClickBack} title={title} />
        <View
          style={{
            flexGrow: 1,
            position: 'relative'
          }}>
          {isBanned ? (
            <RestrictionMessage stateName={currentLocationState} />
          ) : (
            <>
              {gameType === Constants.GameType.FANTASY_CRICKET && (
                <MatchTabCricket gameType={Constants.GameType.FANTASY_CRICKET} />
              )}
              {gameType === Constants.GameType.FANTASY_FOOTBALL && (
                <MatchTabFootball gameType={Constants.GameType.FANTASY_FOOTBALL} />
              )}

              {gameType === Constants.GameType.FANTASY_YES_NO && (
                <MatchTabYesNo gameType={Constants.GameType.FANTASY_YES_NO} />
              )}
            </>
          )}
        </View>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default FantasyHomeMWeb;
